<span class="order-detail-row__icon"
  ><ng-content select="[meta-icon]"></ng-content></span
><span class="order-detail-row__content" [attr.data-testid]="contentTestId"
  ><ng-content></ng-content
></span>
